export default "__VITE_ASSET__DnUyyR5s__"